var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.container},[_c('n8n-loading',{attrs:{"loading":!_vm.showPreview,"rows":1,"variant":"image"}}),_c('iframe',{ref:"preview_iframe",class:{
			[_vm.$style.workflow]: !this.nodeViewDetailsOpened,
			[_vm.$style.openNDV]: this.nodeViewDetailsOpened,
			[_vm.$style.show]: this.showPreview,
		},attrs:{"src":"/workflows/demo"},on:{"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }